// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import Vuex from "vuex";
import store from "@/store/store";
import "lib-flexible/flexible";
import "./assets/style/api.css";
import VueScroller from "vue-scroller";
import Calendar from "vue-mobile-calendar";
import "./assets/style/swiper.min.css";
import "./assets/js/swiper.min.js";
import "./styles/index.scss";
Vue.use(Calendar);
Vue.config.productionTip = false;
Vue.use(VueScroller);
Vue.use(Vuex);

import VDistpicker from "v-distpicker";
Vue.component("v-distpicker", VDistpicker);

import { post, fetch, patch, put, posts } from "./utils/http";
//定义全局变量
Vue.prototype.$post = post;
Vue.prototype.$fetch = fetch;
Vue.prototype.$patch = patch;
Vue.prototype.$put = put;
Vue.prototype.$posts = posts;

import VueCookies from "vue-cookies";
Vue.use(VueCookies);

import { Button, Cell, Navbar, TabItem } from "mint-ui";
Vue.component(Navbar.name, Navbar);
Vue.component(TabItem.name, TabItem);
Vue.component(Button.name, Button);
Vue.component(Cell.name, Cell);
router.beforeEach((to, from, next) => {
  if (to.name == "order") {
    let hotelType = sessionStorage.hotelType;
    if (hotelType == "1") {
      to.meta.title = "员工免费房";
    } else {
      to.meta.title = "员工特惠房";
    }
  }
  next();
});

new Vue({
  el: "#app",
  router,
  store,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js